import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const AT: DeepPartial<Payments> = {
    checkDomesticMatchString: /^[\w öäüÖÄÜß()&.,-/+<>?;!"={}:_%*#§|\\$^[\]'\u20AC@]+$/.toString(),
    putCancelledByUserToDone: true,
    urgentBadgeInSigning: false,
    balanceToCalculateRemainingAmount: 'balance',
    collectiveSigning: {
        showExtendedLabels: true,
    },
    shouldClearPaymentFormOnIdNotFoundError: true,
    isPrioritizedGroupAccountsSearchEnabled: true,
    isoTransferDateFormatEnabled: false,
    redoReplyEngine: 'paymentService',
};
